"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadFile = void 0;

var UploadFile =
/** @class */
function () {
  function UploadFile(file) {
    this.$file = file;
  }

  Object.defineProperty(UploadFile.prototype, "id", {
    /**
     * A unique UUID referencing this file in the Flatfile system
     */
    get: function get() {
      return this.$file.id;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UploadFile.prototype, "filename", {
    /**
     * The original filename on the user's system
     */
    get: function get() {
      return this.$file.filename;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UploadFile.prototype, "filesize", {
    /**
     * The size of the file in bytes
     */
    get: function get() {
      return this.$file.filesize;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UploadFile.prototype, "filetype", {
    /**
     * The type of file
     */
    get: function get() {
      return this.$file.filetype;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(UploadFile.prototype, "url", {
    /**
     * A securely signed url giving you temporary access to download the file
     */
    get: function get() {
      return this.$file.url;
    },
    enumerable: false,
    configurable: true
  });
  return UploadFile;
}();

exports.UploadFile = UploadFile;